import { supabase } from '@/integrations/supabase/client';
import { MASTER_TENANT_ID } from '@/types/tenant';

type TenantLike = {
  tenant_id?: string | null;
  id?: string | null;
} | null | undefined;

export interface ScopedCompany {
  id: string;
  name: string;
  tenant_id?: string | null;
  root_company_id?: string | null;
}

export function resolveTenantId(tenant: TenantLike, userTenantId?: string | null): string | null {
  return tenant?.tenant_id || tenant?.id || userTenantId || null;
}

export async function fetchTenantScopedCompanies({
  tenantId,
  isMasterTenant,
  select = 'id, name',
  activeOnly = true,
}: {
  tenantId?: string | null;
  isMasterTenant: boolean;
  select?: string;
  activeOnly?: boolean;
}): Promise<ScopedCompany[]> {
  if (!isMasterTenant && (!tenantId || tenantId === MASTER_TENANT_ID)) {
    return [];
  }

  let query = supabase.from('companies').select(select);

  if (activeOnly) {
    query = query.eq('is_active', true);
  }

  if (!isMasterTenant) {
    query = query.eq('tenant_id', tenantId);
  }

  const { data, error } = await query.order('name');
  if (error) throw error;

  return (data || []) as ScopedCompany[];
}
